const collapsedClass = 'collapsed';
const expandedClass = 'expanded';
const activeClass = 'active';
const searchFormSelector = '.searchbar';
const searchResetSelector = '[type="reset"]';
const searchLoadSelector = '.search-loader';
const searchInputSelector = '.search-input';
const suggestionsSelector = '.suggestions';
const searchResultTextSelector = '.text';
const suggestionsApiAttribute = 'data-suggestions-api';
const typingDelay = 100;
const oemSlug = document.querySelector('meta[name="cv-oem-slug"]');
const majorVersion = document.querySelector('meta[name="cv-major-version"]');
const minorVersion = document.querySelector('meta[name="cv-minor-version"]');
const navSlug = document.querySelector('meta[name="cv-nav-slug"]');
const searchVendor = document.querySelector('meta[name="search-vendor"]');


function initSearchbars() {
    document.querySelectorAll(searchFormSelector).forEach(form => {
        const input = form.querySelector(searchInputSelector);
        const suggestionsApi = input.hasAttribute(suggestionsApiAttribute) ? input.getAttribute(suggestionsApiAttribute) : '/api/search/suggest';
        const suggestionsList = form.querySelector(suggestionsSelector);
        const recentSearchesKey = 'cv-recent-searches';
        let suggestionsCache = {};
        let previousRequest = {controller: null};
        let recentSearches;
        let delayedSearch;

        form.setAttribute('data-results', 'false');

        const getQuery = () => {
            return input.value;
        };

        const getRecentSearches = () => {
            if (recentSearches) {
                return recentSearches;
            }
            const savedSearchString = localStorage.getItem(recentSearchesKey);
            if (savedSearchString) {
                return JSON.parse(savedSearchString);
            }
            const init = [];
            localStorage.setItem(recentSearchesKey, JSON.stringify(init));
            return init;
        };

        const addRecentSearchQuery = () => {
            const time = new Date().getTime();
            const query = getQuery();
            recentSearches = getRecentSearches();
            recentSearches.filter(item => {
                if (item.query === query) {
                    const index = recentSearches.indexOf(item);
                    recentSearches.splice(index, 1);
                }
            });
            if (query.trim().length > 0) {
                recentSearches.push({'query': query, 'time': time});
                // sort by most recent first
                recentSearches = recentSearches.sort((a, b) => b.time - a.time);
                // keep only the 5 most recent
                recentSearches = recentSearches.slice(0, 5);
                localStorage.setItem(recentSearchesKey, JSON.stringify(recentSearches));
            }
        };

        const removeRecentSearchQuery = (query) => {
            recentSearches = getRecentSearches();
            recentSearches.filter(item => {
                if (item.query === query) {
                    const index = recentSearches.indexOf(item);
                    recentSearches.splice(index, 1);
                }
            });
            localStorage.setItem(recentSearchesKey, JSON.stringify(recentSearches));
        };

        const makeRecentSearchItem = text => {
            const li = document.createElement('li');
            const textNode = document.createElement('span');
            const icon = document.createElement('i');
            const clearBtn = document.createElement('button');
            const clearIcon = document.createElement('i');
            li.classList.add('recent-search');
            textNode.classList.add('text');
            icon.classList.add('fa');
            icon.classList.add('fa-clock');
            clearBtn.classList.add('btn');
            clearBtn.classList.add('clear');
            clearIcon.classList.add('fa');
            clearIcon.classList.add('fa-times');
            textNode.innerText = text;
            clearBtn.appendChild(clearIcon);
            li.appendChild(icon);
            li.appendChild(textNode);
            li.appendChild(clearBtn);
            return li;
        };

        const makeSuggestionItem = text => {
            const li = document.createElement('li');
            const textNode = document.createElement('span');
            const icon = document.createElement('i');
            li.classList.add('suggestion');
            textNode.classList.add('text');
            icon.classList.add('fa');
            icon.classList.add('fa-search');
            textNode.innerText = text;
            li.appendChild(icon);
            li.appendChild(textNode);
            return li;
        };

        const paintRecentSearches = () => {
            suggestionsList.innerHTML = '';
            recentSearches = getRecentSearches();
            recentSearches.forEach(item => {
                const li = makeRecentSearchItem(item.query);
                suggestionsList.appendChild(li);
            });
        };

        const paintResults = suggestions => {
            suggestionsList.innerHTML = '';
            const query = getQuery().trim();
            const queryLowerCase = query.toLowerCase();
            let recentSearchesCopy = getRecentSearches().slice();
            recentSearchesCopy = recentSearchesCopy.filter(item => item.query.toLowerCase().includes(queryLowerCase));
            recentSearchesCopy.forEach(item => {
                const li = makeRecentSearchItem(item.query);
                suggestionsList.appendChild(li);
            });
            suggestions.forEach(item => {
                const li = makeSuggestionItem(item);
                suggestionsList.appendChild(li);
            });
        };

        const tabThroughResults = e => {
            let arrowKey = false;

            // change the key name for ie
            if (e.key === 'Up' || e.key === 'ArrowUp') {
                arrowKey = 'up';
            }
            if (e.key === 'Down' || e.key === 'ArrowDown') {
                arrowKey = 'down';
            }

            if (arrowKey) {
                const resultItems = suggestionsList.querySelectorAll('li');
                const activeResult = suggestionsList.querySelector(`.${activeClass}`);
                let newActiveResult;
                if (activeResult) {
                    activeResult.classList.remove(activeClass);
                    for (let i = 0; i < resultItems.length; i++) {
                        if (resultItems[i] === activeResult) {
                            switch (arrowKey) {
                                case 'up':
                                    if ((i - 1) >= 0) {
                                        newActiveResult = resultItems[i - 1];
                                    }
                                    break;
                                case 'down':
                                    if ((i + 1) < resultItems.length) {
                                        newActiveResult = resultItems[i + 1];
                                    }
                                    break;
                            }
                            break;
                        }
                    }
                }
                if (!newActiveResult) {
                    switch (arrowKey) {
                        case 'up':
                            newActiveResult = resultItems[resultItems.length - 1];
                            break;
                        case 'down':
                            newActiveResult = resultItems[0];
                            break;
                    }
                }
                newActiveResult.classList.add(activeClass);
                input.value = newActiveResult.querySelector(searchResultTextSelector).innerText;
                return true;
            }
            return false;
        };

        const doSearch = e => {
            const query = getQuery().trim();
            form.setAttribute('data-results', 'loading');
            if (previousRequest.controller) {
                previousRequest.controller.abort();
                previousRequest = {};
            }
            if (query.length === 0) {
                form.setAttribute('data-results', 'false');
                suggestionsCache = {};
                paintRecentSearches();
                return;
            }
            if (query in suggestionsCache) {
                const cachedSuggestions = suggestionsCache[query];
                form.setAttribute('data-results', 'true');
                paintResults(suggestionsCache[query]);
                return;
            }
            const controller = new AbortController();
            const {signal} = controller.signal;
            previousRequest.controller = controller;
            previousRequest.query = query;
            clearTimeout(delayedSearch);
            delayedSearch = setTimeout(() => {
                    fetch(`${suggestionsApi}?q=${encodeURIComponent(query)}`, signal)
                        .then(response => response.json())
                        .then(data => {
                            form.setAttribute('data-results', 'true');
                            previousRequest = {controller: null};
                            const suggestions = data['data'];
                            suggestionsCache[query] = suggestions;
                            paintResults(suggestions);
                        })
                        .catch(err => {
                            form.setAttribute('data-results', 'true');
                            if (err.name !== "AbortError") {
                                console.log(err);
                            }
                        })
                }, typingDelay
            );
        };

        const handleKeydown = e => {
            if (e.keyCode === 13 || e.key === 'Enter') {
                e.preventDefault();
                handleSubmit(e);
            }
        };

        const handleInput = e => {
            if (tabThroughResults(e)) {
                return;
            }
            doSearch(e);
        };

        const handleSubmit = e => {
            e.preventDefault();
            addRecentSearchQuery();
            // const action_url = form.getAttribute('action');
            const isCoveoSearch = searchVendor.getAttribute('content').toLowerCase() === 'coveo';
            const params = {
                q: getQuery(),
                oem: oemSlug.getAttribute('content'),
                majorVersion: majorVersion.getAttribute('content'),
                minorVersion: minorVersion.getAttribute('content'),
                site: navSlug.getAttribute('content'),
            }
            let searchURL = '/search?';
            let paramKeys = Object.keys(params);
            paramKeys.forEach( (key, idx) =>{
                searchURL += `${key}=${encodeURIComponent(params[key])}`;
                if (idx < paramKeys.length - 1){
                    searchURL += '&';
                }
            });
            if (isCoveoSearch && (params.oem === 'commvault' || params.oem === 'metallic')) {
                const commonVersion = `${params.majorVersion}.${params.minorVersion}`;
                searchURL += `#q=${encodeURIComponent(params.q)}`;
            }
            window.location = searchURL;
        };

        const handleReset = e => {
            e.preventDefault();
            input.value = '';
            form.setAttribute('data-results', 'false');
            input.focus();
            suggestionsCache = {};
            e.stopPropagation();
        };

        const handleFocus = e => {
            form.classList.add(expandedClass); //expand the width of the input if expanded
            const query = getQuery().trim();
            if (query.length === 0) {
                paintRecentSearches();
            }
            suggestionsList.classList.remove(collapsedClass);
            suggestionsList.classList.add(expandedClass);
            const outsideClick = (ev) => {
                if (ev.target.closest(searchInputSelector) !== input && ev.target.closest(suggestionsSelector) !== suggestionsList) {
                    suggestionsList.classList.remove(expandedClass);
                    suggestionsList.classList.add(collapsedClass);
                    document.removeEventListener('click', outsideClick);
                    if (getQuery().trim().length === 0) {
                        form.classList.remove(expandedClass);
                    }
                }
            };
            document.addEventListener('click', outsideClick);
        };

        const handleResultClick = e => {
            const clickedResult = e.target.closest('li');
            const clickedClear = e.target.closest('.clear');
            if (clickedClear) {
                const query = clickedResult.querySelector(searchResultTextSelector).innerText;
                removeRecentSearchQuery(query);
                clickedResult.remove();
                e.stopPropagation();
            } else if (clickedResult) {
                input.value = clickedResult.querySelector(searchResultTextSelector).innerText;
                handleSubmit(e);
            }
        };

        input.addEventListener('focus', handleFocus);
        input.addEventListener('keydown', handleKeydown);
        input.addEventListener('keyup', handleInput);
        form.addEventListener('submit', handleSubmit);
        form.addEventListener('reset', handleReset);
        suggestionsList.addEventListener('click', handleResultClick);
    });
}


export default initSearchbars;